import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import { useStores } from "_common/hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { formatNumber } from "_common/utils/formatValue";
import HeaderTop from "_common/component/Layout/Header/HeaderTop";
import { useQuery } from "@tanstack/react-query";
import { PriceApi } from "states/api/price";
import classNames from "classnames";
import i18next from "i18next";

const Forex = observer(() => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const {
    authStore: { banners, top_coin, forex },
  } = useStores();

  const [gameList, setGameList] = useState(forex);
  const [random, setRandom] = useState(0);

  const { data, refetch } = useQuery(
    ["forex", "price"],
    () =>
      PriceApi.getList({
        params: {
          page: 1,
          limit: 50,
          exchange: "forex",
          ...params,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    const interval = setInterval(() => {
      refetch();
    }, 30000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setRandom((Math.floor(Math.random() * 100) + 1) / 5000);
    }, 3000);

    return () => {
      clearInterval(interval);
    };
  }, [random]);

  const coinListPrice = useMemo(
    () =>
      gameList.map((item) => {
        const price = data?.find(
          (obj) => obj?.symbol?.toLowerCase() === item?.code
        );

        const lastPrice = Number(price?.close);
        const priceChangePercent = Number(price?.changeRatio);
        const percentRandom = priceChangePercent + random;

        return {
          ...item,
          price: {
            ...price,
            lastPrice: lastPrice + (lastPrice * percentRandom) / 100,
            priceChangePercent: percentRandom,
          },
        };
      }),
    [gameList, data, random]
  );

  return (
    <div className="coin-list">
      <div className="list">
        <div className="item header">
          <div className="col1 text-[#707A8A]">Giao dịch</div>
          <div className="col2 text-[#707A8A]">{i18next.t("latest_price")}</div>
          <div className="col3 text-[#707A8A]">24H Số lượng</div>
        </div>
        {coinListPrice?.map((item) => (
          <a
            href={`/trade?symbol=${item?.code}&type=forex`}
            className="item"
            key={item?.id}
          >
            <div className="col1 !flex-row">
              <img
                src={item?.image_url}
                alt=""
                width="20"
                height="20"
                className="mr-[10px]"
              />
              <p className="name">
                <b>{item?.name}</b>
              </p>
            </div>
            <div className="col2">
              <span
                className={classNames({
                  "text-green": item?.price?.priceChangePercent > 0,
                  "text-red": item?.price?.priceChangePercent <= 0,
                })}
              >
                {formatNumber(item?.price?.lastPrice, "0,0.[000]")}
              </span>
            </div>
            <div className="col3">
              <span
                className={classNames("tag ", {
                  green: item?.price?.priceChangePercent > 0,
                  red: item?.price?.priceChangePercent <= 0,
                })}
              >
                {formatNumber(item?.price?.priceChangePercent, "0,0.[00]")}%
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
});

export default Forex;
